import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IForgotPasscodeResentOtpRequest, IForgotPasscodeResentOtpResponse } from '../models/forgot-passcode-resend-otp.model';
import {
  loadForgotPasscodeResendOtp,
  loadForgotPasscodeResendOtpSuccess,
  loadForgotPasscodeResendOtpFailure,
  clearForgotPasscodeResendOtp
} from '../actions/forgot-passcode-resend-otp.actions';

export const forgotPasscodeResendOtpFeatureKey = 'forgotPasscodeResendOtp';

export interface ForgotPasscodeResendOtpState {
  isLoading: boolean;
  forgotPasscodeResendOtpRequest: IForgotPasscodeResentOtpRequest;
  forgotPasscodeResendOtpResponse: IForgotPasscodeResentOtpResponse;
  forgotPasscodeResendOtpFailure: IGenericError<ErrorResponse>;
}

export const initialState: ForgotPasscodeResendOtpState = {
  isLoading: false,
  forgotPasscodeResendOtpRequest: undefined,
  forgotPasscodeResendOtpResponse: undefined,
  forgotPasscodeResendOtpFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadForgotPasscodeResendOtp, (state, action) => ({
    ...state,
    forgotPasscodeResendOtpRequest: action.request,
    isLoading: true
  })),

  on(loadForgotPasscodeResendOtpSuccess, (state, action) => ({
    ...state,
    forgotPasscodeResendOtpResponse: action.response,
    isLoading: false
  })),

  on(loadForgotPasscodeResendOtpFailure, (state, action) => ({
    ...state,
    forgotPasscodeUserNeedsHelpFailure: action.error,
    isLoading: false
  })),

  on(clearForgotPasscodeResendOtp, (state, action) => ({
    ...state,
    forgotPasscodeResendOtpResponse: undefined
  }))
);

export const getForgotPasscodeResendOtpRequest = (state: ForgotPasscodeResendOtpState) => state.forgotPasscodeResendOtpRequest;
export const getForgotPasscodeResendOtpResponse = (state: ForgotPasscodeResendOtpState) => state.forgotPasscodeResendOtpResponse;
export const getForgotPasscodeResendOtpFailure = (state: ForgotPasscodeResendOtpState) => state.forgotPasscodeResendOtpFailure;
export const getForgotPasscodeResendOtpIsLoading = (state: ForgotPasscodeResendOtpState) => state.isLoading;
